import axios from 'axios';
import store from '../store/store';
import router from '../router';

const instance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  timeout: 10000000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
  },
});
instance.interceptors.response.use(
  (response) => {
    return response;
  }, (error) => {
    const isIncludingLogout = error.request.responseURL.includes('logout');
    if (!error.request) {
      store.commit('AuthStore/clearPermissions');
      router.push('/login');
    }
    if (error.request.status === 401 && !isIncludingLogout) {
      store.dispatch('AuthStore/logout')
        .then(() => {
          router.push('/login');
        });
      throw error;
    } else if (error.request.status === 401 && isIncludingLogout) {
      store.commit('AuthStore/clearPermissions');
          router.push('/login');
      throw error;
    }
    throw error;
  },
);
export default instance;
